import { tx } from "@/i18n/tx";
import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { api, fmtCHF, fmtDate } from "@/lib/api";

const fmtAt = (iso) => new Date(iso).toLocaleString("fr-CH", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
const ROWS = [
  ["sh_date", (o) => fmtDate(o.date)],
  ["sh_sp", (o) => fmtCHF(o.ca_sur_place || 0)],
  ["sh_em", (o) => fmtCHF(o.ca_emporter || 0)],
  ["sh_cards", (o) => fmtCHF(o.montant_cartes || 0)],
  ["TWINT", (o) => fmtCHF(o.montant_twint || 0)],
  ["sh_cash", (o) => (o.cash_compte == null ? "—" : fmtCHF(o.cash_compte))],
  ["sh_float", (o) => (o.fond_caisse == null ? "—" : fmtCHF(o.fond_caisse))],
  ["sh_total", (o) => fmtCHF(o.total_ttc || 0)],
  ["sh_vat", (o) => (o.total_tva == null ? "—" : fmtCHF(o.total_tva))],
  ["sh_covers", (o) => o.nb_couverts ?? 0],
];

export default function SaleHistory({ saleId }) {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const toggle = async () => {
    if (items) { setItems(null); return; }
    setLoading(true);
    try { const { data } = await api.get(`/sales/${saleId}/history`); setItems(data); } finally { setLoading(false); }
  };
  return (
    <div className="w-full">
      <button type="button" onClick={toggle} className="text-xs font-semibold text-primary-c flex items-center gap-1" data-testid={`sale-history-toggle-${saleId}`}>
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <History className="w-3.5 h-3.5" />}
        {items ? tx("ui_salehistory.k695745") : tx("ui_salehistory.k4c9a3e")}
      </button>
      {items && (
        <ol className="mt-2 space-y-2" data-testid={`sale-history-${saleId}`}>
          {items.map((h, i) => (
            <li key={h.at + i} className="rounded-xl bg-surface-muted p-3 text-xs space-y-1.5" data-testid={`sale-history-item-${saleId}-${i}`}>
              <p className="font-semibold">Version archivée le {fmtAt(h.at)}</p>
              <p><span className="text-text-secondary">{tx("ui_salehistory.kdd8a97")} </span>{h.reason || tx("ui_salehistory.k4e8b5b")}</p>
              <dl className="grid grid-cols-2 gap-x-3 gap-y-0.5">
                {ROWS.map(([l, f]) => (<div key={l} className="contents"><dt className="text-text-secondary">{tx(`tpl.${l}`)}</dt><dd className="text-right font-medium">{f(h.old)}</dd></div>))}
              </dl>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
